import { render, staticRenderFns } from "./updateInAppContent.vue?vue&type=template&id=8ba32266&"
import script from "./updateInAppContent.vue?vue&type=script&lang=js&"
export * from "./updateInAppContent.vue?vue&type=script&lang=js&"
import style0 from "./updateCampaignContent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports